<template>
  <g>
    <path
      d="M15.63 18.63a2.44 2.44 0 11-4.67.95l4.06-1.78c.25.22.47.5.61.83M3.1 12.18C1.94 9.3 2.52 6.55 4.23 4.75c-.07-.1-.14-.2-.2-.33a2.44 2.44 0 114.48-1.96c.05.12.08.24.1.36a7.17 7.17 0 016.43 4.17s1.96 4.5 4.11 4.86c.07 0 1.22.03 1.58.87.33.8-.36 1.86-1.55 2.37L6.31 20.64c-1.19.52-2.5.31-2.78-.5-.28-.8.33-1.55.39-1.62 1.22-1.87-.83-6.34-.83-6.34"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NotificationHeaderIcon",
});
</script>
